// extracted by mini-css-extract-plugin
export var hexAnimation = "hex-animation-module--hex-animation--9jaM0";
export var hexAnimationSpinDown = "hex-animation-module--hex-animation--spin-down--BkttJ";
export var hexAnimationSpinUp = "hex-animation-module--hex-animation--spin-up--lbEuO";
export var spinDown = "hex-animation-module--spin-down--O0SQv";
export var spinUp = "hex-animation-module--spin-up--V+GFQ";